module.exports = __webpack_public_path__ + "static/Doingud-9526bae92677a6920e2b3672f9b0048a.png";